import reduxUtils from '../reduxUtils';

const tabGroupActions = {
  ...(reduxUtils.getActions('tabGroups')),
};

export default tabGroupActions;
